import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=62cad65f&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=62cad65f&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62cad65f')) {
      api.createRecord('62cad65f', component.options)
    } else {
      api.reload('62cad65f', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=62cad65f&", function () {
      api.rerender('62cad65f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data/components/detail.vue"
export default component.exports